<div class="dialog-content single-action-dialog">
  <!--title 標題-->
  @if (data.title) {
    <h1 class="dialog-title" [innerHTML]="data.title"></h1>
  }
  <!--btn:關閉按鈕-->
  @if (data.showCloseButton) {
    <button mat-button (click)="close()" class="dialog-close-btn">
      <img src="assets/img/i-close.svg" alt="" />
    </button>
  }

  <!--dialog 內容-->
  @if (data.message) {
    <div mat-dialog-content>
      <p class="dialog-subtitle" [innerHTML]="data.message"></p>
    </div>
  }
  <button class="btn-fill-primary btn-size-l" (click)="data.action()">
    {{ data.buttonText }}
  </button>
</div>
